<template>
    <div>
        <div class="table-layout mt10">
            <el-table ref="multipleTable" :data="retailerList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
                <el-table-column v-if="multiSelect" width="50" align="center" type="selection" :selectable="selectable"></el-table-column>
                <el-table-column v-if="!multiSelect" width="55" align="center">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : selectMerchant.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="160" align="left" prop="name" label="客户名称" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" align="center" prop="adminPhoneNo" label="管理员账号"></el-table-column>
                <el-table-column width="120" align="left" prop="orgCode" label="组织机构代码" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" align="left" prop="socialCreditCode" label="统一社会信用代码" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" align="left" prop="no" label="系统编号"></el-table-column>
                <el-table-column width="120" align="left" prop="industryType.name" label="行业类型"></el-table-column>
                <el-table-column width="100" align="left" prop="contactName" label="联系人"></el-table-column>
                <el-table-column width="100" align="center" prop="contactTel" label="联系电话"></el-table-column>
                <el-table-column align="left" prop="briefIntro" label="客户介绍" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>

        <div class="block pagination-layout" v-if="totalCount > 10">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import retailerApi from '../../api/retailer'
    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-platform-retailer-list-select',
        desc: '平台零售商户-选择',
        props: {
            multiSelect: {
                type: Boolean,
                default: false
            },
            checkedIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            checkedItem: {//单选初始选择项
                type: Object,
                default: null
            },
            seachQueryModel: {
                type: Object,
                default: function () {
                    return {
                        filterItems: {},
                        sortItemList: [],
                        sortItems: {}
                    };
                }
            },
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                checked: true,
                retailerList: [],
                name: null,
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                checkedList: [],
                //
                selectMerchant: {},
            }
        },
        watch: {
            seachQueryModel(newVal, oldVal){
                if(newVal != oldVal) {
                    //
                    this.queryModel = Utils.merge({}, newVal);
                    this.getMerchantBizRelList();
                }
            },
            checkedItem(newVal, oldVal){
                if(newVal != oldVal) {
                    //
                    this.selectMerchant = Utils.merge({}, newVal);
                    this.retailerList = Utils.merge([], this.retailerList);
                }
            },
            checkedIds(newVal, oldVal){
                let self = this;
                if(newVal != oldVal) {
                    //
                    self.checkedIniting = true;
                    self.$refs[self.checkedTblRefId].clearSelection();
                    newVal = newVal == null ? [] : newVal.clone();
                    oldVal = oldVal == null ? [] : oldVal.clone();
                    let rows = this.retailerList;
                    rows.forEach(function (row) {
                        if(newVal.indexOf(row.id) >= 0) {
                            self.$refs[self.checkedTblRefId].toggleRowSelection(row);
                        }
                    });
                    self.checkedIniting = false;
                }
            },
        },
        created: function () {
            let self = this;
            self.pageSize = self.pageSizes.first();
            this.selectMerchant = this.checkedItem || {};
            //
            self.checkedIdsX = self.checkedIds.clone();
            this.checkedIdsX.forEach(function (id) {
                let item = {};
                item.id = id;
                self.checkedList.add(item);
            });
            self.getMerchantBizRelList();
        },
        methods: {
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                //
                this.getretailerList();
            },
            // ===================== 分页多选开始 ==============================
            addCheckId: function (id, val) {
                if(!this.checkedIdsX.contains(id)) {
                    this.checkedIdsX.add(id);
                    this.checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if(self.checkedIdsX.contains(id)) {
                    for(let i = 0; i < self.checkedList.length; i++) {
                        let checkedMku = self.checkedList[i];
                        if(checkedMku.id == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    self.checkedIdsX.remove(id);
                    return id;
                }
                return null;
            },

            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let allIds = self.retailerList.pluck("id");
                let selIds = selRows.pluck("id");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },

            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },

            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },

            // ===================== 分页多选结束 ==============================
            //===========回显禁用===============
            selectable: function (row, index) {
                let self = this;
                let checkedIds = self.checkedIds;
                if(checkedIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            //===========回显禁用结束===============
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getMerchantBizRelList();
            },

            getMerchantBizRelList: function () {
                let self = this;
                let params = {
                    peerMerchantType: getEnumInfoWith('merchantType', 'name', 'Retailer').value
                };
                merchtComnApi.getMerchantBizRelPeerMerchantIdsByContextAndPeerMerchantTypeAndUnBlock(params, function (result) {
                    if(result.type == 'info') {
                        let ids = result.data || [];
                        if(ids.length > 0) {
                            self.getRetailerList(ids);
                        } else {
                            self.retailerList = [];
                            setTimeout(function () {
                                self.restoreSelRows(self.retailerList, self.checkedTblRefId, 'id');
                            }, self.checkedDelay);
                        }
                    }
                });
            },

            getRetailerList: function (ids) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                //
                filterItems.disabled = false;
                filterItems.ids = ids;
                //
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let resultData = result.data;
                        self.retailerList = resultData.rows;
                        //
                        self.totalCount = resultData.pagination.totalCount;
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.retailerList, self.checkedTblRefId, 'id');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 单选
            handleCurrentChange: function (val) {
                if(!this.multiSelect) {
                    let checkedItem = this.selectMerchant;
                    if(val != null && val.id != checkedItem.id) {
                        this.selectMerchant = Utils.merge({}, val);
                        this.$emit("handle-change", val);

                    }
                }
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                if(this.multiSelect) {
                    let multipleSelection = self.checkedList;
                    result.data = multipleSelection;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/platformRetailer/RetailerForSelect.vue